import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {ApiService} from '@abstract/api.service';

@Injectable()
export abstract class BaseProvider<T> {
    /**
     * Дефолтное значение, чтобы использовать его при ошибках
     * @type {null}
     */
    public defaultValue = null;

    public data$ = new BehaviorSubject<T>(null);

    public hasError = false;

    /**
     * Запрос идет?
     * Проверяется в провайдерах, чтобы не посылать запрос, если он уже идет,
     * а просто дождаться получения новых данных
     * @type {boolean}
     */
    public isFetching = false;

    protected constructor(
        protected _service: ApiService
    ) {}

    /**
     * Преобразовать данные, полученные от сервиса.
     * Можно переопределить метод при наследовании, чтобы делать преобразования в провайдерах,
     * которым эта нужно
     * @param {T} data
     * @returns {T}
     */
    public processedData(data: any): T {
        return data;
    }

    /**
     * Проверка пермишенов перед тем, как сделать запрос за данными к API
     */
    public checkPermissions(): boolean {
        return true;
    }

    /**
     * Обновить данные от сервиса новым запросом
     */
    public updateData(): void {
        if (this.isFetching) {
            return;
        }

        /**
         * Если у пользователя нет пермишенов, то просто прокидываем дефолтные значения и не паримся
         */
        if (!this.checkPermissions()) {
            this.data$.next(this.processedData(this.defaultValue));
            return;
        }

        this.isFetching = true;
        this.hasError = false;

        this._service.get().toPromise().then((data: T) => {
            this.data$.next(this.processedData(data));
            this.isFetching = false;
            this.hasError = false;
        }, () => {
            this.isFetching = false;
            this.hasError = true;
            /**
             * При ошибке прокидываем дальше дефолтное значение и показываем уведомление об ошибке
             */
            this.data$.next(this.processedData(this.defaultValue));
        });
    }

    public clearData(): void {
        this.data$.next(this.processedData(this.defaultValue));
    }
}
